/**
 * La couleur d'axe d'une bulle (ticket 06 de retours-testeurs) : celle de l'étape du premier
 * tour qui la contient, `var(--axe-N)`. Le serveur donne le rang de l'axe (`carte.axes`,
 * `domain/carte/carte.ts`) ; la Carte et, depuis le ticket 11, la Hiérarchie le lisent ici, pour
 * que les mêmes bulles aient la même couleur dans les deux vues.
 */

/** Combien de couleurs d'axe (`--axe-1` à `--axe-7`, jetons.css) : au-delà, elles reprennent. */
const COULEURS_D_AXE = 7;

export function couleurDAxe(axes: Record<string, number>, id: string): string | null {
  const axe = axes[id];
  return axe === undefined ? null : `var(--axe-${(axe % COULEURS_D_AXE) + 1})`;
}
